import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { SharedUiFormModule } from '@fantaz/shared/ui/form';
import { EditInfoDialogComponent } from './edit-info-dialog.component';
import { LetDirective } from '@ngrx/component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedUiFormModule,
    LetDirective,
    MaterialModule,
  ],
  declarations: [EditInfoDialogComponent],
  exports: [EditInfoDialogComponent],
})
export class UserVerificationUiEditInfoDialogModule {}
